import * as yup from "yup";
import dayjs from "dayjs";
import { MAX_CHAR_TEXTAREA, substitutionReasonValue } from "./types";
import { ILocation, RentalLocationType } from "../../types";
import { validateLocationDate } from "../../utils";

export const validationSchema = yup.object({
    eventInfo: yup
        .object({
            reason: yup
                .string()
                .nullable()
                .required("message.validation.required")
            ,
            eventDate: yup
                .date()
                .typeError("message.validation.invalid_date")
                .nullable()
                .required("message.validation.required")
                .test(
                    'testEventDate',
                    'message.validation.date_not_allowed',
                    (value, context) => {
                        const date: dayjs.Dayjs | null = value ? dayjs(value) : null;
                        // @ts-ignore
                        const pickupDateRa = context?.from[1].value?.originRaData?.pickupDate;
                        const tomorrow = dayjs().add(1, 'day')
                        return !!date?.isBefore(tomorrow,'day') && (date?.isAfter(pickupDateRa) || !!date?.isSame(dayjs(pickupDateRa)));
                    }
                )
            ,
            eventPlaceCountry: yup
                .string()
                .nullable()
                .required("message.validation.required")
            ,
            eventPlaceProvince: yup
                .string()
                .nullable()
                .required("message.validation.required")
            ,
            eventPlaceCity: yup
                .string()
                .nullable()
                .required("message.validation.required")
            ,
            eventPlacePostalCode: yup
                .string()
                .nullable()
                .required("message.validation.required")
            ,
            eventPlaceStreetName: yup
                .string()
                .nullable()
                .required("message.validation.required")
            ,
            eventPlaceStreetNumber: yup
                .string()
                .nullable()
                .required("message.validation.required")
            ,
            eventDescription: yup
                .string()
                .nullable()
                .required("message.validation.required")
                .test(
                    'descriptionLength',
                    '',
                    (value) => {
                        return !value || value.length <= MAX_CHAR_TEXTAREA ;
                    }
                )
            ,
            notePoliceInvolved: yup
                .string()
                .nullable()
                .test(
                    'noteRequired',
                    'message.validation.required',
                    (value, context) => {
                        return !(context?.parent?.policeInvolved && !value);
                    }
                )
                .test(
                    'noteLength',
                    '',
                    (value) => {
                        return !value || value.length <= MAX_CHAR_TEXTAREA ;
                    }
                ),
        }),
    assets: yup
        .object({
            denunciaFurtoSmarrimento: yup
                .mixed()
                .nullable()
                .test(
                    'testDenunciaFurtoSmarrimentoReq',
                    'message.validation.required',
                    (value, context) => {
                        // @ts-ignore
                        const reason = context?.from[1]?.value?.eventInfo?.reason;
                        return !([substitutionReasonValue.FURTO_VEICOLO].includes(reason) && !value);
                    }
                )
        }),
    carToReplace: yup
        .object({
            dropoffDate: yup
                .date()
                .typeError("message.validation.invalid_date")
                .nullable()
                .test(
                    'testDropoffDateToReplace',
                    'message.validation.date_not_allowed',
                    (value, context) => {
                        // @ts-ignore
                        const vehicleAvailability = context?.from[1]?.value?.eventInfo?.vehicleAvailability;
                        if(!vehicleAvailability) {
                            return true;
                        }
                        const date: dayjs.Dayjs | null = value ? dayjs(value) : null;
                        // @ts-ignore
                        const dropoffDateRa = context?.from[1].value?.originRaData?.dropoffDate;
                        const yesterday = dayjs().subtract(1, 'day')
                        const selectedLocation: ILocation | null = context.parent.dropoffLocation;
                        return (!!date?.isBefore(dayjs(dropoffDateRa)) || !!date?.isSame(dayjs(dropoffDateRa))) && date?.isAfter(yesterday,'day') && validateLocationDate(date, selectedLocation, RentalLocationType.Dropoff);
                    }
                )
            ,
        }),
    replacementCar: yup
        .object({
            pickupDate: yup
                .date()
                .typeError("message.validation.invalid_date")
                .nullable()
                .required("message.validation.required")
                .test(
                    'testPickupDateReplacement',
                    'message.validation.date_not_allowed',
                    (value, context) => {
                        const date: dayjs.Dayjs | null = value ? dayjs(value) : null;
                        // @ts-ignore
                        const dropoffDateRa = context?.from[1].value?.originRaData?.dropoffDate;
                        const yesterday = dayjs().subtract(1, 'day');
                        const selectedLocation: ILocation | null = context.parent.pickupLocation;
                        const dmsAssociatedOperator= context?.options?.context?.dmsAssociatedOperator ?? [];
                        return (!!date?.isBefore(dayjs(dropoffDateRa)) || !!date?.isSame(dayjs(dropoffDateRa))) && date.isAfter(yesterday, 'day') && validateLocationDate(date, selectedLocation, RentalLocationType.Pickup, dmsAssociatedOperator);
                    }
                )
                .test(
                    'max30DaysReplacement',
                    'message.validation.dropoff_date_over_30_days_pickup_date',
                    (value, context) => {
                        const date: dayjs.Dayjs | null = value ? dayjs(value) : null;
                        // @ts-ignore
                        const dropoffDateRa = context?.from[1].value?.originRaData?.dropoffDate;
                        if(!date) return true;

                        return dropoffDateRa.isBefore(date.add(30, "day").add(1, 'm'));
                    }
                )
        })
});
